import { useStaticQuery, graphql } from 'gatsby'

export default function useGetAllBuilderProducts() {
    const data = useStaticQuery(graphql`
        query {
            allBuilderModels {
                moogProduct(limit: 1000, options: { cachebust: true }){
                    data {
                        name
                        featured
                        categories
                        longDescription
                        releaseDate
                        shortDescription
                        thumbnail
                        url
                    }
                }
            }
        }
    `)
    return data.allBuilderModels.moogProduct
}
